export const HANDOVER_TYPES = {
  delivery: 0,
  return: 1,
};
